import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Marquee from "react-fast-marquee";
import Menu from "./Menu";
import Booking from "./Booking";
import Slider from "./Slider";
import Dataentry from "./Dataentry";
import SiteFooter from "./SiteFooter";
import axios from 'axios';
import Live from './Live';
import Popup from './Popup';
import Rightside from './Rightside';
import Rolling from './Rolling';
import Video from "./Video";

// const API_BASE = "http://localhost/myapp/api/uploads";

const API_BASE = "https://atblogin.cubixsystems.com/myapp/api/uploads";

function Home() {

	const [uploads, setUploads] = useState([]);
	const [editId, setEditId] = useState(null);
	const [editName, setEditName] = useState('');

	useEffect(() => {
		fetchUploads();
	}, []);

	const fetchUploads = async () => {
		const res = await axios.get(`${API_BASE}/get.php`);
		setUploads(res.data);
	};

	const handleDelete = async (id) => {
		if (!window.confirm("Delete this record?")) return;
		await axios.post(`${API_BASE}/delete.php`, { id });
		fetchUploads();
	};

	const startEdit = (item) => {
		setEditId(item.id);
		setEditName(item.name);
	};

	const saveEdit = async () => {
		await axios.post(`${API_BASE}/update.php`, { id: editId, name: editName });
		setEditId(null);
		fetchUploads();
	};



	return (
		<div>
			{/* <Live /> */}
			{/* <Popup /> */}
			{/* <div className="row slider" style={{backgroundImage:'url(./images/spst-pl.jpg)',backgroundSize:'cover',backgroundPosition:'center',display:'flex',alignItems:'end',justifyContent:'center'}}>
		
		<div style={{width:'800px'}}>
			<img src="./images/spst-home-icon.png" alt="logo" className="homeimage" style={{width:'100%'}} />
		</div>
	</div> */}

			{/* Video Slider
	<div className="video-container">
      <video
        className="background-video"
        autoPlay
        loop
        muted
        playsInline
		style={{width:'100%',height:'100%'}}
      >
        <source src="./images/spst.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
</div> */}



			{/* <Popup /> */}
			{/* <Live /> */}
			{/* <!-- Sections --> */}
			{/* <Popup /> */}
			<Slider />
			{/* <img src="./images/pic-1.jpeg" alt="image" style={{width:'100%'} }/> */}
			<Rolling />

			{/* <div style={{width:'100%'}}>
			<img src="./images/pic-3.jpeg" style={{width:'100%'}} /> <br />
			<img src="./images/pic-6.jpeg" style={{width:'100%'}} />
		</div> */}

			{/* <div style={{width:'auto',marginLeft:'auto',marginRight:'auto',borderBottom:'1px solid maroon',padding:'20px'}}>
						<p className="cloak" style={{textAlign:'center',fontSize:'12pt',fontWeight:'700',color:'black'}}>Temple Cloak Room Timings | Morning: 03:30 am to 02:00 pm & Evening: 03:30 pm to 09:00 pm</p>
					</div> */}


			<div className="row rowspace" >
				<div className="col-md-8" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
					<div className="row rowspace">
						{/* <div className="col-md-4">
							<img src="./images/ayappan.png" alt="" style={{ width: '100%' }} />
						</div> */}
						<div className="col-md-12">
							<div className="row">
								<div className="col-md-3 col-6 godbox">
									<Link to="https://booking.ayyappatempleborivili.in/Default.aspx?i=4">
										<div classname="dgodbox">
											<img src="./images/ganapathy.png" alt="" style={{ width: '60%' }} />
											<p className="dgodboxtext">Ganapathy</p>
										</div>
									</Link>
								</div>
								<div className="col-md-3  col-6  godbox">
									<Link to="https://booking.ayyappatempleborivili.in/Default.aspx?i=2">
										<div classname="dgodbox">
											<img src="./images/vishnu.png" alt="" style={{ width: '60%' }} />
											<p className="dgodboxtext">Guruvayurappan</p>
										</div>
									</Link>
								</div>
								<div className="col-md-3  col-6  godbox">
									<Link to="https://booking.ayyappatempleborivili.in/Default.aspx?i=1">
										<div classname="dgodbox">
											<img src="./images/ayyappan.png" alt="" style={{ width: '60%' }} />
											<p className="dgodboxtext">Ayyappan</p>
										</div>
									</Link>
								</div>
								<div className="col-md-3  col-6  godbox">
									<Link to="https://booking.ayyappatempleborivili.in/Default.aspx?i=3">
										<div classname="dgodbox">
											<img src="./images/devi.png" alt="" style={{ width: '60%' }} />
											<p className="dgodboxtext">Devi</p>
										</div>
									</Link>
								</div>

							</div>
						</div>
					</div>

					<Booking />
				</div>
				<div className="col-md-4" style={{ border: '1px solid silver', borderRadius: '10px', boxShadow: '0px 0px 10px silver inset', padding: '5px', paddingBottom: '20px' }}>
					<Rightside />
				</div>
			</div>

			<div class="grouped_sections" style={{ backgroundSize: 'cover', backgroundAttachment: 'fixed', backgroundPosition: 'center' }}>

				<div class="container">
					<div class="row">

						{/* <!-- Why Choose Us --> */}

						<div class="col-lg-12 grouped_col" style={{ background: 'rgb(114, 0, 0)', padding: '35px', boxShadow: '10px 10px 5px black', borderRadius: '15px' }}>
							<div class="grouped_title" style={{ color: 'white', fontWeight: '300' }}></div>
							<div className="row">
								<div className="col-md-12">
									<div class="menwomen">
										<h3 class="orange" >About Temple</h3>
										<p class="white">In the year 1998, a few ardent devotees of Lord Ayyappa fro	Ayyappa Seva Sangham-Saibaba Nagar situated at Saibaba Nagar, Borivali (W) and the Zeal CHS Pilgrimage Unit at Ram Nagar in Borivali (W) in Mumbai came together to form the Sree Ayyappa Seva Sangham-Saibaba Nagar. It is a Public Charitable Trust registered under The Bombay Public Trust Act, 1950, and Societies Registration Act, 1860. The Founder President of this organization is Shri A K G Nair, the Founder Secretary Shri T Muraleedharan Nair and the Founder Treasurer Shri K V Karthikeyan.
											With persistent and dedicated efforts, the Sangham acquired a plot of land in Ram Nagar for the construction of a Temple of Lord Ayyappa. During the Ashtamangalya Prashnam conducted by the renowned astrologer, Jyothish Ratnam, Shri Edappal Shoolapani Warrier, it was revealed that hundreds of years ago there existed a temple in the acquired land. It was also revealed then, that the main deity at the proposed Temple Complex should be that of Lord Maha Vishnu.
										</p>
									</div>
								</div>


							</div>


						</div>
					</div>
				</div>
			</div>


			{/* <div className="gosala">
			<div className="overlay">
				<div class="gosaladonate">
					<Link to="£" className="btn btn-primary" style={{padding:'20px',background:'orange',color:'maroon',fontSize:'14pt',fontWeight:'400',border:'1px solid orange'}}>Donations</Link>
					
				</div>
				
				
			</div>
			
	</div> */}




		</div>

	);
}

export default Home;